function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_805",
  className: "st0",
  d: "M37.4,35.1V23.7c0-0.6-0.5-1.1-1.1-1.1h-3.7c-0.6,0-1.1,0.5-1.1,1.1v7.7h-7.7 c-0.6,0-1.1,0.5-1.1,1.1v3.7c0,0.6,0.5,1.1,1.1,1.1h11.4C36.4,37.4,37.4,36.4,37.4,35.1C37.4,35.1,37.4,35.1,37.4,35.1z"
});

var SvgCompressLightSolid = function SvgCompressLightSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "R\\xE9teg_1",
    focusable: "false",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.7 48.7",
    style: {
      enableBackground: "new 0 0 48.7 48.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompressLightSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/compress-light-solid.8ed4c2b3.svg";
export { ForwardRef as ReactComponent };